"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.reportWebVitals = exports.log = void 0;
var shared_1 = require("./shared");
var logger_1 = require("./logger");
Object.defineProperty(exports, "log", { enumerable: true, get: function () { return logger_1.log; } });
var url = "".concat(shared_1.proxyPath, "/web-vitals");
var throttledSendMetrics = (0, shared_1.throttle)(sendMetrics, 1000);
var collectedMetrics = [];
function reportWebVitals(metric) {
    var _a;
    collectedMetrics.push(__assign({ route: (_a = window.__NEXT_DATA__) === null || _a === void 0 ? void 0 : _a.page }, metric));
    // if Axiom env vars are not set, do nothing,
    // otherwise devs will get errors on dev environments
    if (!shared_1.isEnvVarsSet) {
        return;
    }
    throttledSendMetrics();
}
exports.reportWebVitals = reportWebVitals;
function sendMetrics() {
    var body = JSON.stringify({
        webVitals: collectedMetrics,
    });
    if (shared_1.isBrowser && navigator.sendBeacon) {
        navigator.sendBeacon(url, body);
    }
    else {
        fetch(url, { body: body, method: 'POST', keepalive: true });
    }
    collectedMetrics = [];
}
//# sourceMappingURL=webVitals.js.map